import { Directive, Host, HostListener } from '@angular/core';

@Directive({
  selector: '[appNgbDateInputMask]',
  standalone: false
})
export class NgbDateInputMaskDirective {
  constructor() {}

  preventEventPropagation(event: any, value: any) {
    event.preventDefault();
    event.stopPropagation();
    if (event.target) {
      event.target.value = value;
    }
  }

  // This can be modified to allow partial date completion.
  @HostListener('change', ['$event']) onChange(event: any) {
    const { target } = event;
    const { value } = target;
    // Only allow a valid date format of MM/DD/YYYY
    if (
      !/^(([0]?[0-9])|([1][0-2]))\/(([0-2]?[0-9])|([3][0-1]))\/([0-9]{4})$/.test(
        value
      )
    ) {
      event.target.value = null;
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: any) {
    const { key, target, ctrlKey, metaKey } = event;
    const { value } = target;

    // Allow backspacing and tabbing
    if (!['Backspace', 'Tab'].includes(key)) {
      // If the key is not a digit or forward slash, disallow unless the user is pressing the Meta key or Ctrl Key
      if (/[^\d\/]/.test(key) && !ctrlKey && !metaKey) {
        this.preventEventPropagation(event, value);
      }
      // Only allow a forward slash character if the current input value is 2 or 5 characters long (MM/DD/YYYY)
      if (/[\/]/.test(key) && ![2, 5].includes(value.length)) {
        this.preventEventPropagation(event, value);
      }
      if (/[\d]/.test(key) && !ctrlKey && !metaKey) {
        // If the length is greater than 9 (date should only be 10 characters long MM/DD/YYYY)
        // The 10th character should be replaced with the newly typed character.
        if (value.length > 9) {
          event.target.value = value.slice(0, 9);
        }
        if (value.length === 2) {
          event.target.value = value.concat('/');
        }
        if (value.length === 5) {
          event.target.value = value.concat('/');
        }
      }
    }
  }
}
